module.exports = __webpack_public_path__ + "img/accompagner_temps.cd210719.png";